module.exports = __webpack_public_path__ + "static/media/edit@2x.8770388f.svg";